import axios from "axios";
import { config } from "../config/config";

const axiosInstance = axios.create({
  baseURL: config.base.url,
  timeout: 5000,
  withCredentials: true,
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    config.headers["Content-Type"] = "multipart/form-data";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
